import React, { useState, useEffect, useContext, useRef } from "react";

import { CountdownCircleTimer } from "react-countdown-circle-timer";

import DataContext from "../../../utils/Context/DataContext";
import { AntDesign, Entypo, Feather } from "@expo/vector-icons";

import { Link, useParams } from "react-router-dom";
import { api } from "../../../utils/Api";
import {
  Ionicons,
  MaterialCommunityIcons,
  MaterialIcons,
  FontAwesome,
} from "@expo/vector-icons";

import { makeStyles } from "@material-ui/core/styles";
import ModalOrderTracking from "./ModalOrderTracking";
import InfiniteScroll from "react-infinite-scroll-component";

import ModalOrderConfirmed from "./ModalOrderConfirmed";
import ModalChooseItems from "./ModalChooseItems";
import ModalPackageDetails from "./ModalPackageDetails";
import ModalEditPackageDetails from "./ModalEditPackageDetails";
import ModalEditItems from "./ModalEditItems";
import ModalPrepareTime from "./ModalPrepareTime";
import ModalDeleteShipment from "./ModalDeleteShipment";
import ModalRejected from "./ModalRejected";
import ModalLocationLive from "./ModalLocationLive";
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
} from "@material-ui/core";
import toast, { Toaster } from "react-hot-toast";
import { mobileApp } from "../../../utils/MobileApp";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
import { AppConfig } from "../../../config";
import classNames from "classnames";

const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
  },
  paper: {
    marginRight: theme.spacing(2),
  },
}));

export default function OutletComponent(props: any) {
  // console.log(props);
  const classes = useStyles();
  const [open, setOpen] = React.useState(false);
  const anchorRef = React.useRef(null);
  const context : any = useContext(DataContext);
  const [grid_view, SetGridView] = useState(false);
  const [view_type, SetViewType] = useState("all");
  const [list_view, SetListView] = useState(true);
  const [id_value, SetIdValue] = useState(useParams());
  const [order_data, SetOrderData] = useState([]);
  const [data, SetData] = useState([]);
  const [counter, setCounter] = useState(0);
  const [close, SetClose] = useState(false);
  const [prop_data, SetPropData] = useState(props);
  const [next_page, SetNextPage] = useState(false);
  const [page_no, SetPageNo] = useState(1);
  const [visible_content, SetVisibleContent] = useState(true);

  const [order_tracking_modal, SetOrderTrackingModal] = useState({
    is_open: false,
    lat: "",
    lon: "",
    id: "",
    delivery_id: "",
    delivery_index: "",
    order_data: {},
  });

  const timerProps = {
    isPlaying: true,
    size: 33,
    strokeWidth: 4,
  };

  const renderTime = (dimension: any, time: any) => {
    return (
      <div className="time-wrapper text-black">
        <div className="time center">{time}</div>
        <div>{dimension}</div>
      </div>
    );
  };
  const [openModal, SetopenModal] = useState({
    is_open: false,
    data: {},
  });
  const [prepTimeModal, SetPrepTimeModal] = useState({
    is_open: false,

    brand: id_value.brand_id,
    outlet: id_value.outlet_id,
    approx_time: "",
    order_id: "",
  });
  const [chooseItemModal, SetChooseItemModal] = useState({
    is_open: false,
    data: {},
    id: "",
  });

  const [createPackageModal, SetCreatePackageModal] = useState({
    is_open: false,
    data: {},
    id: "",
  });

  const [editPackageModal, SetEditPackageModal] = useState({
    is_open: false,
    data: {},
    id: "",
  });

  const [editItemModal, SetEditItemModal] = useState({
    is_open: false,
    data: {},
    id: "",
  });

  const [deleteShipModal, SetDeleteShipModal] = useState({
    is_open: false,
    data: {},
  });

  const [rejectModal, SetRejectModal] = useState({
    is_open: false,
    data: {},
  });

  const currentURL = window.location.href;
  const minuteSeconds = 60;
  const hourSeconds = 3600;

  const getTimeMinutes = (time) => ((time % hourSeconds) / minuteSeconds) | 0;

  const stratTime = Date.now() / 1000; // use UNIX timestamp in seconds
  const endTime = stratTime + 243248; // use UNIX timestamp in seconds

  const remainingTime = endTime - stratTime;
  const [mapdriverModal, SetMapDriverModal] = useState({
    is_open: false,
    lat: "",
    lon: "",
    id: "",
  });
  const [new_orders_available, SetNewOrdersAvailable] = useState(false);
  const [tost_id, SetTostId] = useState([]);
  let orders_call_interval: any;

  useEffect(() => {
    SetOrderData(props.data.orders);
    // orders_call_interval = setInterval(function () {
    //   SetOrderData((prevalue) => {
    //     console.log("order_data in setInterval prevalue:", prevalue);
    //     let order_data: any = [];
    //     prevalue.map((ele: any) => {
    //       order_data.push(ele.id);
    //     });
    //     let send_data = {
    //       orders: order_data,
    //     };
    //     get_timed_orders(send_data);
    //     return [...prevalue];
    //   });
    // }, 20000);
    call_timed_function();
    return () => {
      clearInterval(orders_call_interval);
    };
  }, []);

  useEffect(() => {
    console.log("useEffect On id_value change  :", props);
    SetIdValue((prevalue: any) => {
      console.log("SetIdValue prevalue :", prevalue);
      return prevalue;
    });
    // if (props.open) {
    // get_order(props.view);
    SetOrderData(props.data.orders);
    SetData(props.data.options);
    SetNextPage(props.data.next_page);
    SetViewType(props.view);
    SetPageNo(1);
    // clearInterval(orders_call_interval);
    // call_timed_function();
  }, [props]);

  function call_timed_function() {
    orders_call_interval = setInterval(function () {
      SetOrderData((prevalue) => {
        console.log("order_data in setInterval prevalue:", prevalue);
        let order_data: any = [];
        prevalue?.map((ele: any) => {
          order_data.push(ele.id);
        });
        let new_sample_value: any = useParams();
        let send_data = {
          orders: order_data,
          type: new_sample_value.type,
        };
        get_timed_orders(send_data);
        return prevalue;
      });
    }, 20000);
  }

  // const handleToggle = () => {
  //   setOpen((prevOpen) => !prevOpen);

  async function load_more(page_value) {
    let page_no_value = page_no + 1;

    SetPageNo(page_no_value);

    console.log(id_value);
    let pass_data: any = {
      get: {
        brand: id_value.brand_id,
        outlet: id_value.outlet_id,
        view: view_type,
        page: page_value.page_no,
      },
    };

    // if (id_value.order_id) {
    //   pass_data.get.order_id = id_value.order_id;

    //   response = await api("/outlet/order_details", pass_data);
    // }

    let response = await api("/outlet/orders", pass_data);

    if (response?.status_code == 200) {
      console.log("/brand/add_brand_product_list :", response);

      SetOrderData((prevValue) => {
        response.response.orders.map((item) => {
          prevValue.push(item);
        });
        return [...prevValue];
      });
      if (response.response.hasOwnProperty("next_page")) {
        SetNextPage(response.response.next_page);
        SetPageNo((prevalue) => {
          prevalue = prevalue + 1;
          return prevalue;
        });
      }
    }
  }

  const handleClose = (event: any) => {
    if (anchorRef.current && anchorRef.current.contains(event.target)) {
      return;
    }

    setOpen(false);
  };

  const prevOpen = React.useRef(open);
  React.useEffect(() => {
    if (prevOpen.current === true && open === false) {
      anchorRef.current.focus();
    }

    prevOpen.current = open;
  }, [open]);

  async function get_order(view: any) {
    SetViewType(view);
    let pass_data: any = {
      get: {
        brand: id_value.brand_id,
        outlet: id_value.outlet_id,
      },
    };

    let response;

    if (id_value.order_id) {
      pass_data.get.order_id = id_value.order_id;

      response = await api("/outlet/order_details", pass_data);
    }

    if (view) {
      pass_data.get.view = view;
      pass_data.get.page = 1;

      response = await api("/outlet/orders", pass_data);
    }

    if (response?.status_code == 200) {
      if (response.response.hasOwnProperty("orders")) {
        let orders = response.response.orders;
        orders.map((ele: any) => {
          ele.open_prepare_data = false;
        });
        SetOrderData(orders);
        SetData(response?.response?.options);
      }
    }
  }

  async function get_timed_orders(get_data: any) {
    let pass_data: any = {
      get: {
        brand: id_value.brand_id,
        outlet: id_value.outlet_id,
        orders: encodeURI(JSON.stringify(get_data.orders)),
        view: get_data.type,
      },
    };
    console.log("get_timed_orders pass_data :", pass_data);

    let response: any = await api("/outlet/get_orders", pass_data);
    console.log("/outlet/get_orders :", response);
    if (response.status_code == 200) {
      if (response.response.hasOwnProperty("orders")) {
        let orders = response.response.orders;
        // orders.map((ele: any) => {
        //   ele.open_prepare_data = false;
        // });
        // SetOrderData(orders);

        SetOrderData((prevalue) => {
          orders.map((ele) => {
            let found = prevalue.find((element: any) => element.id == ele.id);
            console.log("found :", found);
            if (found == undefined) {
              ele.open_prepare_data = false;
            } else {
              let index = prevalue.findIndex(
                (element: any) => element.id == ele.id
              );
              if (index != -1) {
                ele.open_prepare_data = prevalue[index].open_prepare_data;
              }
            }
          });
          console.log("SetOrderData prevalue : ", prevalue);
          console.log("SetOrderData orders : ", orders);
          prevalue = orders;
          return [...prevalue];
        });

        SetData(response?.response?.options);
      }
      if (response.response.new_order > 0) {
        SetNewOrdersAvailable(true);
        // generate_toast();
        props.on_new_order(true);
      } else {
        SetNewOrdersAvailable(false);
        props.on_new_order(false);
      }
    }
  }

  // Function is called everytime increment button is clicked
  const handleClick1 = (get_data: any) => {
    // Counter state is incremented
    // max_preparation_duration

    SetOrderData((prevalue: any) => {
      let sec_value = prevalue[get_data.index].max_preparation_duration;
      let minutes = Math.floor(sec_value / 60);
      setCounter((prevalue1: any) => {
        if (prevalue1 < minutes) {
          prevalue1 = prevalue1 + 1;
        } else {
          console.log("on high counter prevalue :", prevalue1);
          console.log("on high minutes :", minutes);
        }
        return prevalue1;
      });
      return [...prevalue];
    });
  };

  // Function is called everytime decrement button is clicked
  const handleClick2 = () => {
    // Counter state is decremented
    setCounter((prevalue: any) => {
      if (prevalue > 0) {
        prevalue = prevalue - 1;
      }
      return prevalue;
    });
  };

  function ModalOnClose(data: any) {
    SetopenModal({
      is_open: false,
      data: {},
    });
    if (data.action == "delete") {
      console.log("on confirm delete :", data.value);
      delete_user(data.value.element, data.value.index);
    }

    SetPrepTimeModal({
      is_open: false,

      brand: id_value.brand_id,
      outlet: id_value.outlet_id,
      approx_time: "",

      order_id: "",
    });
  }

  async function accept(order_id: any) {
    let pass_data: any = {
      get: {
        brand: id_value.brand_id,
        outlet: id_value.outlet_id,
        order_id: order_id,
      },

      post: {
        status: "Accept",
        // outlet : id_value.outlet_id,
        // order_id : order_id,
      },
    };
    console.log("remove_owner record :", order_id);

    let data = await api("/outlet/update_order_status", pass_data);
    console.log("/outlet/update_order_status :", data);
    if (data.status_code == 200) {
      const ring = {
        function: "refreshringnotifications",
        app_type: "react_web",
      };
      mobileApp(ring);
      get_order(id_value.type);
    }
  }

  async function submit_ready(delivery_id: any) {
    let pass_data: any = {
      get: {
        brand: id_value.brand_id,
        outlet: id_value.outlet_id,
        delivery_id: delivery_id,
      },

      post: {
        status: "Accept",
        // outlet : id_value.outlet_id,
        // order_id : order_id,
      },
    };
    console.log("remove_owner record :", order_id);

    let data = await api("/outlet/update_order_status", pass_data);
    console.log("/outlet/update_order_status :", data);
    if (data.status_code == 200) {
      get_order(id_value.type);
    }
  }

  async function submit_ready_ship(r_id: any) {
    // props.close();

    let pass_data = {
      get: {
        brand: id_value.brand_id,
        outlet: id_value.outlet_id,
        delivery_id: r_id,
      },
      post: {
        status: "Ready",
      },
    };

    console.log("pass_data :", pass_data);

    let data_res = await api("/outlet/update_delivery_status", pass_data);
    console.log("/outlet/update_delivery_status :", data_res.response);
    if (data_res.status_code == 200) {
      let item = close_data;
      // SetStatus(true);
      // item.action = "edit";
      item.value = data_res.response.orders[0];
      // item.index = props.data.index;
      // console.log("Close data : ", item);
      // SetCloseData(item);
      // SetFranchiseData(franchise_initial_value);
      // myModal.hide();
      // console.log("gfrhjgf")
      // props.close();
    }
  }

  async function update_prepare(id: any) {
    let pass_data = {
      get: {
        brand: id_value.brand_id,
        outlet: id_value.outlet_id,
        order_id: id,
      },
      post: {
        duration: counter,
        status: "Accept",
      },
    };
    console.log("pass_data :", pass_data);

    let data_res = await api("/outlet/update_order_status", pass_data);
    console.log("/outlet/update_delivery_package :", data_res);

    if (data_res.status_code == 200) {
      get_order(id_value.type);
    }
  }

  async function del_partner_number(id: any, del_id: any) {
    let pass_data = {
      get: {
        brand: id_value.brand_id,
        outlet: id_value.outlet_id,
        order_id: id,
        callto: "delivery_partner",
        delivery_id: del_id,
      },
    };
    console.log("pass_data :", pass_data);

    let data_res = await api("/outlet/call", pass_data);
    console.log("/outlet/call :", data_res);

    if ((data_res.status_code = 200)) {
      // if (data_res?.response?.phone_number) {
      //   // document.location.href = 'tel:'+data_res?.response?.phone_number;
      //   window.open("tel:" + data_res?.response?.phone_number);
      // }
      if (data_res?.response?.phone_number) {
        if (context?.app_data.application?.platform == "android") {
          window.open("tel:" + data_res?.response?.phone_number);
        } else {
          window.location.href = "tel:" + data_res?.response?.phone_number;
        }
      }
      {
        /* <a
                                              href={
                                                "tel:" +
                                                ele.delivery[0]
                                                  .hyperlocal_pickup
                                                  .delivery_partner_mobile
                                              }
                                            > */
      }
      // get_order(id_value.type);
    }
  }

  function generate_toast() {
    toast((t) => (
      <span
        onClick={() => {
          SetTostId((prevalue) => {
            prevalue.push(t.id);
            return [...prevalue];
          });
          toast.dismiss();
          get_order(props.view);
        }}
      >
        <b>New Orders Available</b>
        <p className="cursor m-3 center">Click To Reload</p>
      </span>
    ));
  }

  function get_status_class(ele: any) {
    let return_data = "";
    if (ele.order_status == "New") {
      return_data = "bg-red status-round";
    } else if (ele.order_status == "Processing") {
      return_data = "bg-prime status-round";
    } else if (ele.order_status == "Completed") {
      return_data = "bg-green status-round";
    } else if (
      ele.order_status == "Rejected" ||
      ele.order_status == "Cancelled"
    ) {
      return_data = "bg-red status-round";
    } else {
      return_data = "bg-prime status-round";
    }
    return return_data;
  }

  return (
    <div className="w-100 orders_list_page">
      <div className="">
        {props.is_loading ? (
          [1, 2, 3, 4, 5].map((sk_ele: any) => (
            <div className="row mb-3">
              <div className="col-md-6 mb-2">
                <div className="card p-3">
                  <div className="d-flex">
                    <div className="w-75">
                      <div className="d-flex align-items-center">
                        <Skeleton height={12} width={50} />

                        <div className="ps-1">
                          <Skeleton height={10} width={90} />
                        </div>
                      </div>
                    </div>
                    <div className="w-25 text-end">
                      <Skeleton height={10} width={60} />
                      {/* <Skeleton className="folded-ribbon-gray" /> */}
                    </div>
                  </div>

                  <div className="pt-2 d-flex align-items-center">
                    <Skeleton height={10} width={150} />
                    <div className="ms-auto">
                      <Skeleton height={10} width={100} />
                      {/* <Skeleton className="folded-ribbon-gray" /> */}
                    </div>
                  </div>
                  <div className="my-2 border-bottom-light-2px"></div>

                  <div className="">
                    <div className="d-flex align-items-center mb-3">
                      <Skeleton height={10} width={100} />

                      <div className="ps-1">
                        <Skeleton height={10} width={50} />
                      </div>
                    </div>
                    <div className="d-flex">
                      <div className="w-80 d-flex">
                        <div className="pe-1">
                          <Skeleton height={10} width={20} />
                        </div>
                        <Skeleton height={10} width={150} count={2} />
                      </div>
                      <div className="w-20 end">
                        <div className="d-flex align-items-center">
                          <Skeleton height={10} width={80} />
                        </div>
                      </div>
                    </div>

                    <div className="my-2 border-bottom-light-2px"></div>

                    <div className="d-flex align-items-center">
                      <Skeleton height={10} width={80} />
                      <div className="ms-auto">
                        <Skeleton height={10} width={10} />
                      </div>
                    </div>

                    <div className="d-flex align-items-center mt-3">
                      <Skeleton height={12} width={80} />
                      <div className="ms-auto">
                        <Skeleton height={12} width={50} />
                      </div>
                    </div>

                    <div className="center w-100 mt-3">
                      <Skeleton height={30} width={180} borderRadius={6} />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          ))
        ) : (
          <InfiniteScroll
            dataLength={order_data.length}
            next={() => {
              let get_data = {
                load_more: true,

                page_no: page_no,
              };
              // console.log(pass_data)
              console.log(get_data);

              load_more(get_data);
            }}
            hasMore={next_page}
            loader={
              <div className="center m-5">
                <div className="lds-dual-ring"></div>
                <p className=" small ps-2">Just a second ...</p>
              </div>
            }
          >
            <div className="row">
              <div className="col-md-6">
                {order_data?.map((ele: any, i_item: any) => (
                  <div className="mb-3">
                    <div className="card p-3">
                      <Link
                        to={
                          "/outlet/" +
                          id_value.brand_id +
                          "/" +
                          id_value.outlet_id +
                          "/order_details" +
                          "/" +
                          ele.id
                        }
                        className="text-dark"
                      >
                        <div className="d-flex align-items-center">
                          {/* <div className="ms-auto">
                          {ele.delivery?.map((ele_pro: any, i_item: any) => (
                            <div className="d-flex" key={i_item}>
                              {
                                (ele_pro.status = "Preparing Order" ? (
                                  <div>
                                    <CountdownCircleTimer
                                      {...timerProps}
                                      colors={[
                                        "#1D741B",
                                        "#0E86D4",
                                        "#FF2511",
                                        "#fffff",
                                      ]}
                                      colorsTime={[20, 10, 5, 0]}
                                      duration={hourSeconds}
                                      initialRemainingTime={
                                        ele_pro.remaining_preparing_duration %
                                        hourSeconds
                                      }
                                      onComplete={(totalElapsedTime) => ({
                                        shouldRepeat:
                                          ele_pro.remaining_preparing_duration -
                                            totalElapsedTime >
                                          minuteSeconds,
                                      })}
                                    >
                                      {({ elapsedTime, color }) => (
                                        <span style={{ color }}>
                                          {renderTime(
                                            "",
                                            getTimeMinutes(
                                              hourSeconds - elapsedTime
                                            )
                                          )}
                                        </span>
                                      )}
                                    </CountdownCircleTimer>
                                  </div>
                                ) : null)
                              }
                            </div>
                          ))}
                        </div> */}
                        </div>

                        <div className="d-flex align-items-center">
                          <p className="text-red fw-bold fs-7 pe-2 border-right-2px pop-font">
                            {ele.id}
                          </p>
                          <p className="small text-darkgray ps-2">{ele.time}</p>
                          {ele.delivery?.map(
                            (ele_pro: any) =>
                              ele_pro.remaining_preparing_duration && (
                                <div className="ms-auto d-flex align-items-center">
                                  <p className="text-dark fw-bold fs-8px">
                                    ORDER READY IN
                                  </p>
                                  <span className="ps-1">
                                    <div>
                                      <CountdownCircleTimer
                                        {...timerProps}
                                        colors={[
                                          "#1D741B",
                                          "#0E86D4",
                                          "#FF2511",
                                          "#fffff",
                                        ]}
                                        colorsTime={[20, 10, 5, 0]}
                                        duration={hourSeconds}
                                        initialRemainingTime={
                                          ele_pro.remaining_preparing_duration %
                                          hourSeconds
                                        }
                                        onComplete={(totalElapsedTime) => ({
                                          shouldRepeat:
                                            ele_pro.remaining_preparing_duration -
                                              totalElapsedTime >
                                            minuteSeconds,
                                        })}
                                      >
                                        {({ elapsedTime, color }) => (
                                          <span style={{ color }}>
                                            {renderTime(
                                              "",
                                              getTimeMinutes(
                                                hourSeconds - elapsedTime
                                              )
                                            )}
                                          </span>
                                        )}
                                      </CountdownCircleTimer>
                                    </div>
                                  </span>
                                </div>
                              )
                          )}
                        </div>
                        <div className="pt-2 d-flex align-items-center">
                          <p className="text-black oneline">
                            {ele.customer_name}
                          </p>
                          {/* {ele.delivery?.map((ele_pro: any) => ( */}
                          <div className="ms-auto d-flex align-items-center">
                            <div
                              // className={
                              //   ele.order_status == "New"
                              //     ? "bg-red status-round"
                              //     : ele.order_status == "Processing" ||
                              //       ele_pro.order_status == "Preparing Order"
                              //     ? "bg-prime status-round"
                              //     : ele_pro.order_status ==
                              //         "Ready For Shipment" ||
                              //       ele.order_status == "Completed"
                              //     ? "bg-green status-round"
                              //     : ele.order_status == "Rejected" ||
                              //       ele.order_status == "Cancelled"
                              //     ? "bg-red status-round"
                              //     : "bg-prime status-round"
                              // }
                              className={get_status_class(ele)}
                            ></div>
                            {ele.order_status == "Accepted" ? (
                              ele.delivery?.map((ele_pro) =>
                                ele_pro.hasOwnProperty("status") ? (
                                  ele_pro.status == "Ready For Shipment" ? (
                                    <p className="text-grren fw-bold small capitalize ps-2">
                                      Ready
                                    </p>
                                  ) : (
                                    (ele_pro.status = "Preparing Order" ? (
                                      <p className="text-prime fw-bold small capitalize ps-2">
                                        Preparing
                                      </p>
                                    ) : null)
                                  )
                                ) : (
                                  <p className="text-white fw-bold small capitalize ps-2">
                                    {ele.order_status}
                                  </p>
                                )
                              )
                            ) : ele.order_status == "New" ? (
                              <p className="text-prime fw-bold small capitalize ps-2">
                                {ele.order_status}
                              </p>
                            ) : ele.order_status == "Completed" ? (
                              <p className="text-darkgreen fw-bold small capitalize ps-2">
                                Completed
                              </p>
                            ) : ele.order_status == "Rejected" ? (
                              <p className="text-red fw-bold small capitalize ps-2">
                                Rejected
                              </p>
                            ) : ele.order_status == "Processing" ? (
                              <p className="text-prime fw-bold small capitalize ps-2">
                                {ele.order_status}
                              </p>
                            ) : (
                              <p className="text-red fw-bold small capitalize ps-2">
                                {ele.order_status}
                              </p>
                            )}
                          </div>
                          {/* ))} */}
                        </div>
                      </Link>

                      <div className="my-2 border-bottom-light-2px"></div>
                      {ele.delivery?.map((ele_pro: any, item: any) => (
                        <div>
                          <Link
                            to={
                              "/outlet/" +
                              id_value.brand_id +
                              "/" +
                              id_value.outlet_id +
                              "/order_details" +
                              "/" +
                              ele.id
                            }
                          >
                            <div className="d-flex align-items-center pb-1">
                              <p className="text-black fs-7 pop-font">
                                Shipment {item + 1 + " :"}
                              </p>
                              <p className="text-dark fw-bold ps-2 fs-7 pop-font">
                                {" #" + ele_pro.id}
                              </p>

                              <div className="ms-auto">
                                {" "}
                                {/* <Feather name="edit-3" size={16} color="gray" /> */}
                                {!ele_pro.hyperlocal && (
                                  <div className="dropdown">
                                    <button
                                      className="btn dropdown-toggle px-2 py-0"
                                      type="button"
                                      id="dropdownMenuButton1"
                                      data-bs-toggle="dropdown"
                                      aria-expanded="false"
                                    >
                                      <img
                                        src={
                                          AppConfig.CDN_Media_url +
                                          "606ae5b8e171b0301c3742fede964024.svg"
                                        }
                                        className="w-14px"
                                      />
                                    </button>
                                    <ul
                                      className="dropdown-menu"
                                      aria-labelledby="dropdownMenuButton1"
                                    >
                                      <li>
                                        <a
                                          className="dropdown-item py-2 cursor"
                                          href="#"
                                          onClick={(event) => {
                                            console.log("edit_outlet");
                                            //   SetEditItemModal({
                                            //     is_open: true,
                                            //     id: ele_pro.id,
                                            //     data: {
                                            //       product: ele_pro.products,
                                            //       delivery: ele.delivery,
                                            //       main_product: ele.products,
                                            //     },
                                            //   });

                                            // accept(ele.id);
                                          }}
                                        >
                                          {" "}
                                          <img
                                            src={
                                              AppConfig.CDN_Media_url +
                                              "bfc951e595e2cc12936f5d5f83d79fed.svg"
                                            }
                                            className="w-14px pe-1"
                                          />
                                          {/* // <Feather
                                              //   name="edit-3"
                                              //   size={16}
                                              //   color="gray"
                                              // />{" "} */}
                                          Edit
                                        </a>
                                      </li>
                                      <li>
                                        <a
                                          className="dropdown-item py-2 cursor"
                                          href={
                                            "https://sellers.1superapp.com/app_dev/outlet/download_shipment_invoice?brand=" +
                                            id_value.brand_id +
                                            "&outlet=" +
                                            id_value.outlet_id +
                                            "&delivery_id=" +
                                            ele_pro.id
                                          }
                                          rel="noopener noreferrer"
                                          target="_blank"
                                        >
                                          <img
                                            src={
                                              AppConfig.CDN_Media_url +
                                              "e525368aef5e666c8f5baa3a27fe0416.svg"
                                            }
                                            className="w-14px"
                                          />
                                          Download shipment invoice
                                        </a>
                                      </li>
                                      <li>
                                        <a
                                          className="dropdown-item py-2 cursor"
                                          // href={
                                          //   "https://sellers.1superapp.com/app_dev/outlet/download_shipment_invoice?brand=" +
                                          //   id_value.brand_id +
                                          //   "&outlet=" +
                                          //   id_value.outlet_id +
                                          //   "&delivery_id=" +
                                          //   ele_pro.id
                                          // }
                                          rel="noopener noreferrer"
                                          target="_blank"
                                        >
                                          <img
                                            src={
                                              AppConfig.CDN_Media_url +
                                              "e525368aef5e666c8f5baa3a27fe0416.svg"
                                            }
                                            className="w-14px"
                                          />
                                          Download shipment label
                                        </a>
                                      </li>
                                      <li>
                                        <a
                                          className="dropdown-item py-2 cursor"
                                          // href={
                                          //   "https://sellers.1superapp.com/app_dev/outlet/download_shipment_invoice?brand=" +
                                          //   id_value.brand_id +
                                          //   "&outlet=" +
                                          //   id_value.outlet_id +
                                          //   "&delivery_id=" +
                                          //   ele_pro.id
                                          // }
                                          rel="noopener noreferrer"
                                          target="_blank"
                                        >
                                          <img
                                            src={
                                              AppConfig.CDN_Media_url +
                                              "e525368aef5e666c8f5baa3a27fe0416.svg"
                                            }
                                            className="w-14px"
                                          />{" "}
                                          Download shipment manifest
                                        </a>
                                      </li>
                                      <li>
                                        <a
                                          className="dropdown-item py-2 cursor"
                                          href="#"
                                          onClick={(event) => {
                                            //   SetDeleteShipModal({
                                            //     is_open: true,
                                            //     data: {
                                            //       id: ele_pro.id,
                                            //     },
                                            //   });
                                          }}
                                        >
                                          <img
                                            src={
                                              AppConfig.CDN_Media_url +
                                              "27b1e4dbbad6d871540efbe961718c46.svg"
                                            }
                                            className="w-14px"
                                          />{" "}
                                          Delete
                                        </a>
                                      </li>
                                    </ul>
                                  </div>
                                )}
                              </div>
                            </div>

                            {ele_pro.hasOwnProperty("products") ? (
                              <div>
                                {ele_pro.products?.map(
                                  (item: any, i_item: any) => (
                                    <div className="w-100 mt-2" key={i_item}>
                                      {/* {console.log(
                                      data.image_base_url + "/" + JSON.stringify(item.product_images[0].url)
                                      )}
                                      <img
                                      src={
                                      data.image_base_url +
                                      "320" +
                                      "/" +
                                      JSON.stringify(item.product_images[0].url).replaceAll('"', '')
                                      }
                                      alt="16.a1d4f3f3"
                                      // className="rounded-float-start"
                                      height="80"
                                      width="80"
                                    /> */}
                                      <div className="d-flex">
                                        <div className="w-80 d-flex">
                                          <p className=" text-dark fw-bold pop-font pe-1">
                                            {item.quantity}x
                                          </p>
                                          <p className=" text-dark fw-bold pop-font">
                                            {item.variant_name}
                                          </p>
                                        </div>
                                        <div className="w-20 end">
                                          <div className="d-flex align-items-center">
                                            <img
                                              src={
                                                AppConfig.CDN_Media_url +
                                                "8f3e9e1ce8408aa208f467aee400fa4a.svg"
                                              }
                                              className="w-14px"
                                            />
                                            <p className="text-dark fw-bold pop-font ">
                                              {item.amount}
                                            </p>
                                          </div>
                                        </div>
                                      </div>

                                      <div className="ps-2">
                                        {item.addons?.map(
                                          (addon_i: any, i: any) => (
                                            <div className="d-flex align-items-center">
                                              <img
                                                src={
                                                  AppConfig.CDN_Media_url +
                                                  "1a83becba4a8ed6b86ce57c3e66631f9.svg"
                                                }
                                                className="w-14px"
                                              />
                                              <p className="text-darkgray v-small">
                                                {/* {i != 0 && ", "} */}
                                                {addon_i.quantity} x{" "}
                                                {addon_i.name}
                                              </p>
                                            </div>
                                          )
                                        )}
                                      </div>
                                    </div>
                                  )
                                )}
                              </div>
                            ) : null}
                          </Link>
                          <div className="my-2 border-bottom-light-2px"></div>

                          <div>
                            {ele.sector_id != 2 && (
                              <>
                                {ele_pro.package_details.package_breadth ==
                                null ? (
                                  <div className="py-2  border-top border-bottom mt-3 ">
                                    <div className="d-flex align-items-center">
                                      <p className="mb-1 text-dark">
                                        Package Details
                                      </p>

                                      <div
                                        className="d-flex align-items-center ms-auto cursor"
                                        onClick={(event) => {
                                          SetEditPackageModal({
                                            is_open: true,
                                            id: ele_pro.id,
                                            data: {
                                              // product: ele.products,
                                              units: data.units,
                                              id: ele_pro.id,
                                              package_details:
                                                ele_pro.package_details,
                                            },
                                          });
                                        }}
                                      >
                                        <img
                                          src={
                                            AppConfig.CDN_Media_url +
                                            "bfc951e595e2cc12936f5d5f83d79fed.svg"
                                          }
                                          className="w-10px"
                                        />
                                        <p className="ms-2 text-prime fw-bold v-small">
                                          Edit
                                        </p>
                                      </div>
                                    </div>
                                    <p className="mt-2 v-small text-center">
                                      No Package Data
                                    </p>
                                  </div>
                                ) : (
                                  <div
                                    className="py-2  border-top border-bottom mt-3 
                          
                                      py-1"
                                  >
                                    <div className="d-flex align-items-center">
                                      <p className="mb-2 text-dark">
                                        Package Details
                                      </p>

                                      <div
                                        className="d-flex align-items-center ms-auto cursor"
                                        onClick={(event) => {
                                          SetEditPackageModal({
                                            is_open: true,
                                            id: ele_pro.id,
                                            data: {
                                              // product: ele.products,
                                              units: data.units,
                                              id: ele_pro.id,
                                              package_details:
                                                ele_pro.package_details,
                                            },
                                          });
                                        }}
                                      >
                                        <img
                                          src={
                                            AppConfig.CDN_Media_url +
                                            "bfc951e595e2cc12936f5d5f83d79fed.svg"
                                          }
                                          className="w-10px"
                                        />
                                        <p className="ms-2 text-prime fw-bold v-small">
                                          Edit
                                        </p>
                                      </div>
                                    </div>
                                    <div className="d-flex align-items-center mb-2">
                                      <p className="text-black small">
                                        L x B :{" "}
                                      </p>
                                      <p className="text-darkgray ps-1 small">
                                        {ele_pro.package_details
                                          .package_length +
                                          " " +
                                          ele_pro.package_details
                                            .package_length_unit_name}{" "}
                                        x{" "}
                                        {ele_pro.package_details
                                          .package_breadth +
                                          " " +
                                          ele_pro.package_details
                                            .package_breadth_unit_name}
                                      </p>
                                    </div>

                                    <div className="d-flex align-items-center">
                                      <p className="text-black small">
                                        H x W :{" "}
                                      </p>
                                      <p className="text-darkgray ps-1 small">
                                        {ele_pro.package_details
                                          .package_height +
                                          " " +
                                          ele_pro.package_details
                                            .package_height_unit_name}{" "}
                                        x{" "}
                                        {ele_pro.package_details
                                          .package_weight +
                                          " " +
                                          ele_pro.package_details
                                            .package_weight_unit_name}
                                      </p>
                                    </div>
                                  </div>
                                )}
                              </>
                            )}
                          </div>

                          {/* {delivery person details} */}
                          {ele_pro.hyperlocal == true &&
                            ele_pro.hyperlocal_pickup.delivery_partner_name && (
                              <div className="dperson-details">
                                <Accordion className="px-0" defaultExpanded>
                                  <AccordionSummary
                                    expandIcon={
                                      <img
                                        src={
                                          AppConfig.CDN_Media_url +
                                          "282ebe1d3bff5102145f1f1580afc221.svg"
                                        }
                                        className="w-10px"
                                      />
                                    }
                                    aria-controls="panel1a-content"
                                    id="panel1a-header"
                                    className="px-0 "
                                  >
                                    <p className="text-black fw-bold v-small uppercase">
                                      Delivery Partner Details
                                    </p>

                                    {/* <p className="text-dark fs-7 uppercase fw-bold v-small">
                                                  Bill Details
                                                </p> */}
                                  </AccordionSummary>
                                  <AccordionDetails className="px-0">
                                    <div>
                                      <div className="d-flex ">
                                        {ele.delivery[0].hyperlocal_pickup
                                          .delivery_partner_dp ? (
                                          <img
                                            src={
                                              ele.delivery[0].hyperlocal_pickup
                                                .delivery_partner_dp
                                            }
                                            alt="16.a1d4f3f3"
                                            className="rounded-float-start"
                                            height="34"
                                            width="34"
                                            style={{
                                              borderRadius: "50px",
                                            }}
                                          />
                                        ) : (
                                          <i className="fa fa-user m-2"></i>
                                        )}
                                        <div className="ms-2">
                                          <p className="extra-small text-gray pb-1">
                                            {
                                              ele.delivery[0].hyperlocal_pickup
                                                .company_name
                                            }
                                          </p>

                                          <p>
                                            <span className="fw-bold text-black ">
                                              {
                                                ele.delivery[0]
                                                  .hyperlocal_pickup
                                                  .delivery_partner_name
                                              }
                                            </span>
                                            {/* "15px 50px 30px 5px" */}
                                            <span className="px-1">is</span>
                                            <span
                                              className={
                                                ele.order_status ==
                                                  "Rejected" ||
                                                ele.order_status == "Cancelled"
                                                  ? "text-red v-small ps-0"
                                                  : ele.order_status ==
                                                      "Order Completed" ||
                                                    ele.order_status ==
                                                      "Completed"
                                                  ? "text-green v-small ps-0"
                                                  : "text-prime v-small ps-0"
                                              }
                                            >
                                              {
                                                ele.delivery[0]
                                                  .hyperlocal_pickup.status
                                              }
                                            </span>
                                            {/* {ele.order_status == "Rejected" ? (
                                                          <span className="text-red v-small fw-bold">
                                                            {
                                                              ele.delivery[0]
                                                                .hyperlocal_pickup.status
                                                            }
                                                          </span>
                                                        ) : ele.order_status ==
                                                          "Order Completed" ? (
                                                          <span className="text-green v-small fw-bold">
                                                            {
                                                              ele.delivery[0]
                                                                .hyperlocal_pickup.status
                                                            }
                                                          </span>
                                                        ) : (
                                                          <span className="text-prime v-small fw-bold">
                                                            {
                                                              ele.delivery[0]
                                                                .hyperlocal_pickup.status
                                                            }
                                                          </span>
                                                        )} */}
                                          </p>
                                        </div>
                                        <div className="d-flex align-items-center ms-auto">
                                          {ele.delivery[0].hyperlocal_pickup
                                            .delivery_partner_mobile && (
                                            <div
                                              className="d-flex cursor px-3 border-right"
                                              onClick={() => {
                                                del_partner_number(
                                                  ele.id,
                                                  ele.delivery[0]
                                                    .hyperlocal_pickup
                                                    .delivery_partner_mobile_delivery_id
                                                );
                                              }}
                                            >
                                              {/* <a
                                                            href={
                                                              "tel:" +
                                                              ele.delivery[0]
                                                                .hyperlocal_pickup
                                                                .delivery_partner_mobile
                                                            }
                                                          > */}
                                              <img
                                                src={require("../../../assets/icon/call.png")}
                                                className="logo-img"
                                              />
                                              {/* <Ionicons name="ios-call" size={20} color="green" /> */}
                                              {/* </a>{" "} */}
                                            </div>
                                          )}

                                          {ele.delivery[0].live_tracking ==
                                            true && (
                                            <div className="cursor px-3">
                                              <img
                                                onClick={() => {
                                                  // SetMapDriverModal({
                                                  //   is_open: true,
                                                  //   lat: ele.delivery[0]
                                                  //     ?.hyperlocal_pickup
                                                  //     ?.pickup_lat,
                                                  //   lon: ele.delivery[0]
                                                  //     ?.hyperlocal_pickup
                                                  //     ?.pickup_lng,
                                                  //   id: ele.delivery[0].id,
                                                  // });
                                                  SetOrderTrackingModal(
                                                    (prevalue: any) => {
                                                      prevalue.is_open = true;
                                                      prevalue.delivery_index =
                                                        item;
                                                      prevalue.delivery_id =
                                                        ele_pro.id;
                                                      prevalue.order_data = ele;
                                                      return {
                                                        ...prevalue,
                                                      };
                                                    }
                                                  );
                                                }}
                                                src={
                                                  // "https://img.icons8.com/ios/14/map-marker.png"
                                                  require("../../../assets/icon/map.png")
                                                }
                                                className="delivery"
                                              />
                                            </div>
                                          )}
                                        </div>
                                      </div>

                                      <div className="d-flex align-items-center mt-2">
                                        <div className="d-flex alig-items-center">
                                          {/* <MaterialCommunityIcons name="map-marker-distance" size={12} color="#888" /> */}
                                          <div className="border-left px-1">
                                            {
                                              ele.delivery[0].hyperlocal_pickup
                                                .otp
                                            }
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </AccordionDetails>
                                </Accordion>
                                {/* <p className="text-dark fw-bold mb-1 v-small uppercase">
                                              Delivery Person Details
                                            </p>
                                            <div className="d-flex allign-items-center">
                                            
                                            </div> */}
                              </div>
                            )}

                          {/* {BILL DETAILS} */}

                          <div className="bill-details">
                            <Accordion className="px-0">
                              <AccordionSummary
                                expandIcon={
                                  <img
                                    src={
                                      AppConfig.CDN_Media_url +
                                      "282ebe1d3bff5102145f1f1580afc221.svg"
                                    }
                                    className="w-10px"
                                  />
                                }
                                y
                                aria-controls="panel1a-content"
                                id="panel1a-header"
                                className="px-0 m-0"
                              >
                                <p className="text-dark uppercase v-small fw-bold">
                                  Bill Details
                                </p>
                              </AccordionSummary>
                              <AccordionDetails className="px-0">
                                <div className="w-100">
                                  <div className="d-flex justify-content-between mb-2">
                                    <p className="v-small text-darkgray">
                                      Item total
                                    </p>
                                    <p className="v-small text-darkgray">
                                      <img
                                        src={
                                          AppConfig.CDN_Media_url +
                                          "a7ac4d4f57b56110847ceecdc8636209.svg"
                                        }
                                        className="w-9px"
                                      />
                                      <span className="pop-font ps-1">
                                        {ele.amount}
                                      </span>
                                    </p>
                                  </div>
                                  <div className="d-flex justify-content-between mb-2">
                                    <p className="v-small text-muted text-darkgray">
                                      Package price
                                    </p>
                                    <p className="v-small text-darkgray">
                                      <img
                                        src={
                                          AppConfig.CDN_Media_url +
                                          "a7ac4d4f57b56110847ceecdc8636209.svg"
                                        }
                                        className="w-9px"
                                      />

                                      <span className="pop-font ps-1">0</span>
                                    </p>
                                  </div>
                                  <div className="d-flex justify-content-between mb-2">
                                    <p className="v-small text-muted text-darkgray">
                                      GST
                                    </p>
                                    <p className="v-small text-darkgray">
                                      <img
                                        src={
                                          AppConfig.CDN_Media_url +
                                          "a7ac4d4f57b56110847ceecdc8636209.svg"
                                        }
                                        className="w-9px"
                                      />

                                      <span className="pop-font ps-1">
                                        {ele.gst_amount ? ele.gst_amount : 0}
                                      </span>
                                    </p>
                                  </div>
                                  {/* <div className="d-flex justify-content-between mb-2">
                                        <p className="v-small text-muted text-darkgray">
                                          Discount
                                        </p>
                                        <p className="v-small text-darkgray">
                                          {" "}
                                          &#8377;0.00
                                        </p>
                                      </div> */}
                                  <div className="d-flex justify-content-between mb-2">
                                    <p className="v-small text-muted text-darkgray">
                                      Delivery Charges
                                    </p>
                                    <p className="v-small text-darkgray">
                                      <img
                                        src={
                                          AppConfig.CDN_Media_url +
                                          "a7ac4d4f57b56110847ceecdc8636209.svg"
                                        }
                                        className="w-9px"
                                      />

                                      <span className="pop-font ps-1">
                                        {ele.delivery_charges}
                                      </span>
                                    </p>
                                  </div>
                                </div>
                              </AccordionDetails>
                            </Accordion>
                            {/* <hr className="hr-dotted mt-2 mb-3" /> */}

                            <div className="d-flex align-items-center mt-2">
                              <p className="fw-bold text-black fs-7">
                                Total Bill
                              </p>
                              <p className="text-black fw-bold ms-auto fs-7">
                                <img
                                  src={
                                    AppConfig.CDN_Media_url +
                                    "8f3e9e1ce8408aa208f467aee400fa4a.svg"
                                  }
                                  className="w-14px"
                                />
                                <span className="pop-font ps-1">
                                  {ele.total_amount}
                                </span>
                              </p>
                            </div>

                            {/* <hr className="hr-dotted mt-3 mb-0" /> */}
                          </div>

                          <div className="">
                            {ele.order_status_id != 4 ? (
                              <div className="w-100 center py-2">
                                {ele.order_status_id == 2 ||
                                (ele.order_status_id == 5 &&
                                  ele.delivery[0].status_id == "1") ? (
                                  <button
                                    className="btn bg-prime text-white radius h-42px btn-shadow fw-bold px-4 w-75 cursor mt-2"
                                    style={{ overflow: "hidden" }}
                                    onClick={(event) => {
                                      {
                                        ele_pro.package_details
                                          .package_breadth == null
                                          ? SetCreatePackageModal({
                                              is_open: true,
                                              id: ele_pro.id,
                                              data: {
                                                units: data.units,
                                                id: ele_pro.id,
                                              },
                                            })
                                          : submit_ready_ship(ele_pro.id);
                                      }
                                    }}
                                  >
                                    PREPARING
                                  </button>
                                ) : (
                                  ele.delivery[0].status_id == "3" && (
                                    <button
                                      className="btn bg-prime text-white radius h-42px btn-shadow fw-bold px-4 w-75 cursor mt-2"
                                      style={{ overflow: "hidden" }}
                                      onClick={(event) => {
                                        {
                                          console.log(data);
                                          ele_pro.package_details
                                            .package_breadth == null
                                            ? SetCreatePackageModal({
                                                is_open: true,
                                                id: ele_pro.id,
                                                data: {
                                                  units: data.units,
                                                  id: ele_pro.id,
                                                },
                                              })
                                            : submit_ready_ship(ele_pro.id);
                                        }
                                      }}
                                    >
                                      ORDER READY
                                    </button>
                                  )
                                )}
                              </div>
                            ) : null}

                            {ele_pro.status == "Accepted" && (
                              <div className="w-100 center pb-2">
                                <button
                                  className="btn bg-prime text-white radius h-42px btn-shadow fw-bold px-3 w-75 cursor mt-2"
                                  style={{ overflow: "hidden" }}
                                  onClick={(event) => {
                                    SetPrepTimeModal({
                                      is_open: true,
                                      order_id: ele_pro?.id,
                                    });
                                  }}
                                >
                                  PREPARE
                                </button>
                              </div>
                            )}
                          </div>
                        </div>
                      ))}

                      {ele.products?.length > 0 ? (
                        <>
                          <p className="text-dark fw-bold my-2">
                            Product Details
                          </p>
                          {ele.products?.map((item: any, i_item: any) => (
                            <div className="" key={i_item}>
                              <div className="d-flex">
                                <div className="w-80 d-flex">
                                  <p className=" text-dark fw-bold pop-font pe-1">
                                    {item.quantity}x
                                  </p>
                                  <p className=" text-dark fw-bold pop-font">
                                    {item.variant_name}
                                  </p>
                                </div>
                                <div className="w-20 end">
                                  <div className="d-flex align-items-center">
                                    <img
                                      src={
                                        AppConfig.CDN_Media_url +
                                        "8f3e9e1ce8408aa208f467aee400fa4a.svg"
                                      }
                                      className="w-14px"
                                    />
                                    <p className="ps-1 text-dark fw-bold pop-font ">
                                      {item.amount}
                                    </p>
                                  </div>
                                </div>
                              </div>

                              <div className="ps-2">
                                {item.addons?.map((addon_i: any, i: any) => (
                                  <div className="d-flex align-items-center">
                                    <img
                                      src={
                                        AppConfig.CDN_Media_url +
                                        "1a83becba4a8ed6b86ce57c3e66631f9.svg"
                                      }
                                      className="w-14px"
                                    />

                                    <p className="text-darkgray v-small">
                                      {/* {i != 0 && ", "} */}
                                      {addon_i.quantity} x {addon_i.name}
                                    </p>
                                  </div>
                                ))}
                              </div>
                            </div>
                          ))}
                          {/* {BILL DETAILS} */}

                          <div className="bill-details">
                            <Accordion className="px-0">
                              <AccordionSummary
                                expandIcon={
                                  <img
                                    src={
                                      AppConfig.CDN_Media_url +
                                      "282ebe1d3bff5102145f1f1580afc221.svg"
                                    }
                                    className="w-10px"
                                  />
                                }
                                y
                                aria-controls="panel1a-content"
                                id="panel1a-header"
                                className="px-0 m-0"
                              >
                                <p className="text-dark uppercase v-small fw-bold">
                                  Bill Details
                                </p>
                              </AccordionSummary>
                              <AccordionDetails className="px-0">
                                <div className="w-100">
                                  <div className="d-flex justify-content-between mb-2">
                                    <p className="v-small text-darkgray">
                                      Item total
                                    </p>
                                    <p className="v-small text-darkgray">
                                      <img
                                        src={
                                          AppConfig.CDN_Media_url +
                                          "a7ac4d4f57b56110847ceecdc8636209.svg"
                                        }
                                        className="w-9px"
                                      />
                                      <span className="pop-font ps-1">
                                        {ele.amount}
                                      </span>
                                    </p>
                                  </div>
                                  <div className="d-flex justify-content-between mb-2">
                                    <p className="v-small text-muted text-darkgray">
                                      Package price
                                    </p>
                                    <p className="v-small text-darkgray">
                                      <img
                                        src={
                                          AppConfig.CDN_Media_url +
                                          "a7ac4d4f57b56110847ceecdc8636209.svg"
                                        }
                                        className="w-9px"
                                      />

                                      <span className="pop-font ps-1">0</span>
                                    </p>
                                  </div>
                                  <div className="d-flex justify-content-between mb-2">
                                    <p className="v-small text-muted text-darkgray">
                                      GST
                                    </p>
                                    <p className="v-small text-darkgray">
                                      <img
                                        src={
                                          AppConfig.CDN_Media_url +
                                          "a7ac4d4f57b56110847ceecdc8636209.svg"
                                        }
                                        className="w-9px"
                                      />

                                      <span className="pop-font ps-1">
                                        {ele.gst_amount ? ele.gst_amount : 0}
                                      </span>
                                    </p>
                                  </div>
                                  {/* <div className="d-flex justify-content-between mb-2">
                                        <p className="v-small text-muted text-darkgray">
                                          Discount
                                        </p>
                                        <p className="v-small text-darkgray">
                                          {" "}
                                          &#8377;0.00
                                        </p>
                                      </div> */}
                                  <div className="d-flex justify-content-between mb-2">
                                    <p className="v-small text-muted text-darkgray">
                                      Delivery Charges
                                    </p>
                                    <p className="v-small text-darkgray">
                                      <img
                                        src={
                                          AppConfig.CDN_Media_url +
                                          "a7ac4d4f57b56110847ceecdc8636209.svg"
                                        }
                                        className="w-9px"
                                      />

                                      <span className="pop-font ps-1">
                                        {ele.delivery_charges}
                                      </span>
                                    </p>
                                  </div>
                                </div>
                              </AccordionDetails>
                            </Accordion>
                            {/* <hr className="hr-dotted mt-2 mb-3" /> */}

                            <div className="d-flex align-items-center mt-2">
                              <p className="fw-bold text-black fs-7">
                                Total Bill
                              </p>
                              <p className="text-black fw-bold ms-auto fs-7">
                                <img
                                  src={
                                    AppConfig.CDN_Media_url +
                                    "8f3e9e1ce8408aa208f467aee400fa4a.svg"
                                  }
                                  className="w-14px"
                                />
                                <span className="pop-font ps-1">
                                  {ele.total_amount}
                                </span>
                              </p>
                            </div>

                            {/* <hr className="hr-dotted mt-3 mb-0" /> */}
                          </div>
                        </>
                      ) : null}


                      <div className="">
                        {ele.order_status == "Accepted" &&
                        ele.products.length != 0 ? (
                          <div className="center pt-3">
                            <button
                              className="btn bg-prime text-white btn-round mb-2"
                              style={{ overflow: "hidden" }}
                              onClick={(event) => {
                                SetChooseItemModal({
                                  is_open: true,
                                  id: ele.id,
                                  data: {
                                    product: ele.products,
                                    units: data.units,
                                  },
                                });
                              }}
                            >
                              <span className="btn-inner d-flex align-items-center">
                                <span className="px-lg-4 px-4 fw-bold ">
                                  Plan Shipment
                                </span>
                              </span>
                            </button>
                          </div>
                        ) : (
                          ""
                        )}
                      </div>

                      {ele.open_prepare_data ? (
                        <div className="my-2 card p-3">
                          <p
                            className="text-black mb-2 text-center pop-font"
                            onClick={() => {
                              console.log("ele :", ele);
                            }}
                          >
                            How Long will this take a time to prepare
                          </p>
                          <div className="center py-2">
                            <div className="w-75">
                              <div className="d-flex justify-content-between align-items-center ">
                                <div
                                  className="mb-0 vlr cursor"
                                  onClick={() => {
                                    handleClick2();
                                  }}
                                >
                                  <img
                                    src={
                                      AppConfig.CDN_Media_url +
                                      "853b8c5a78ec1392fe4945a84d80e54f.svg"
                                    }
                                    className="w-30px"
                                  />
                                </div>

                                <p className="mx-2 mb-0  fw-bold text-dark">
                                  {counter} MINS
                                </p>

                                <div
                                  className="mb-0 vlr cursor"
                                  onClick={() => {
                                    let pass_data = {
                                      index: i_item,
                                    };
                                    handleClick1(pass_data);
                                  }}
                                >
                                  <img
                                    src={
                                      AppConfig.CDN_Media_url +
                                      "db6815dd55297e4811896a35ebef902a.svg"
                                    }
                                    className="w-30px"
                                  />
                                </div>
                              </div>
                            </div>
                          </div>
                          <div className="mt-3 d-flex align-items-center">
                            <button
                              className="btn px-3 py-1 text-darkgray bg-fff btn-shadow  btn-radius fw-bold"
                              onClick={() => {
                                SetPrepTimeModal({
                                  is_open: false,
                                  id: "",
                                });
                                SetOrderData((prevalue: any) => {
                                  prevalue[i_item].open_prepare_data = false;
                                  return [...prevalue];
                                });
                              }}
                            >
                              Cancel
                            </button>
                            <div className="ms-auto">
                              <div
                                className="btn text-prime bg-white px-4 py-1 fw-bold btn-shadow btn-radius"
                                onClick={() => {
                                  update_prepare(ele.id);
                                }}
                              >
                                Ok
                              </div>
                            </div>
                          </div>
                        </div>
                      ) : (
                        <div className="">
                          {/* {Accpet & Reject button} */}
                          {ele.order_status_id == 1 && (
                            <div className="row align-items-center py-3">
                              <div className="col-6 text-center">
                                <button
                                  className="btn btn-icon btn-outline-secondary rounded ctc-button "
                                  onClick={(event) => {
                                    SetRejectModal({
                                      is_open: true,
                                      data: {
                                        id: ele.id,
                                      },
                                    });
                                  }}
                                >
                                  <span className="btn-inner d-flex align-items-center">
                                    <span className="px-lg-4 px-4 fw-bold">
                                      REJECT
                                      {/* <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M10.6654 5.33496L5.33203 10.6683" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round">
                                          </path>
                                              <path d="M10.6643 10.6663L5.33203 5.33301" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round">
                                              </path>
                                          </svg> */}
                                    </span>
                                  </span>
                                </button>
                              </div>
                              <div className="col-6 text-center">
                                <button
                                  className="btn btn-icon bg-prime radius text-white ctc-button "
                                  style={{ overflow: "hidden" }}
                                  onClick={(event) => {
                                    console.log("accept");

                                    ele.sector_id == 2 &&
                                    ele.delivery_type_id == 3
                                      ? SetOrderData((prevalue: any) => {
                                          prevalue[i_item].open_prepare_data =
                                            true;
                                          let sec_value =
                                            prevalue[i_item]
                                              .approx_preparation_duration;
                                          let minutes = Math.floor(
                                            sec_value / 60
                                          );
                                          setCounter(minutes);

                                          return [...prevalue];
                                          // prevalue.map((ele:any,index:any)=>{

                                          // })
                                        })
                                      : accept(ele.id);

                                    // SetPrepTimeModal({
                                    //   is_open: true,
                                    //   // id: ele_pro.id,
                                    //   brand: id_value.brand_id,
                                    //   approx_time:
                                    //     ele.approx_preparation_duration,
                                    //   outlet: id_value.outlet_id,
                                    //   order_id: ele.id,
                                    // });
                                  }}
                                >
                                  <span className="btn-inner d-flex align-items-center">
                                    <span className="px-lg-4 px-4 fw-bold">
                                      ACCEPT
                                    </span>
                                  </span>
                                </button>
                              </div>
                            </div>
                          )}
                        </div>
                      )}

                      {/* <hr className="hr-dotted" /> */}

                      {/* <div className="">
                                  <Accordion className="px-0">
                                    <AccordionSummary
                                      expandIcon={
                                        <MaterialIcons
                                          name="keyboard-arrow-down"
                                          size={18}
                                          color="black"
                                        />
                                      }
                                      aria-controls="panel1a-content"
                                      id="panel1a-header"
                                      className="px-0 "
                                    >
                                      <p className="text-black fw-bold v-small uppercase">
                                        Delivery Details
                                      </p>

                                    </AccordionSummary>
                                    <AccordionDetails className="px-0">
                                      <div className=" w-100">
                                        <div className="d-flex align-items-center mb-3">
                                          <p className="text-black fw-bold v-small">
                                            Type
                                          </p>
                                          <p className="ms-auto text-gray v-small">
                                            {ele.delivery_type}
                                          </p>
                                        </div>
                                        <div>
                                          <p className="text-black fw-bold v-small">
                                            Address
                                          </p>
                                          <p className="mt-1 v-small">
                                            {ele?.delivery_address?.address
                                              ? (ele?.delivery_address?.door_no,
                                                ele?.delivery_address?.address,
                                                ele?.delivery_address?.city)
                                              : ele?.delivery_address
                                                  .map_address}
                                            {/* } /}
                                          </p>
                                        </div>
                                      </div>
                                    </AccordionDetails>
                                  </Accordion>
                                </div> */}
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </InfiniteScroll>
        )}
        {/* <div className="card custom-card h-100">
                  <div className="card-body">

                    <Link
                      to={
                        "/outlet/" +
                        id_value.brand_id +
                        "/" +
                        id_value.outlet_id +
                        "/order_details" +
                        "/" +
                        ele.id
                      }
                      className="text-dark"
                    >
                      <div className="d-flex allign-items-center">
                        <div className="d-flex">
                          <img
                            src={ele.customer_dp}
                            alt="16.a1d4f3f3"
                            className="rounded-float-start"
                            height="31"
                            width="31"
                            style={{ borderRadius: "50px" }}
                          />
                          <div>
                            <div className="ms-1 fw-bolder ">
                              {ele.customer_name}

                            </div>
                            <div className=" ms-1">{ele.time}</div>
                          </div>
                        </div>

                        <div className="ms-auto">
                          <div className="ms-2">
                            {ele.order_status}{" "}
                            {ele.order_status == "Rejected" ? (
                              <i
                                className="fa fa-ban text-cl-green"
                                aria-hidden="true"
                              ></i>
                            ) : (
                              <i className="fas fa-shopping-cart text-cl-green"></i>
                            )}
                          </div>
                          <div className="mb-0 fw-bold ms-4">#{ele.id}</div>
                        </div>

                      </div>

                      <hr className="hr-dotted" />
                      {ele.products?.map((item: any) => (
                        <div className="basic-list">

                          <div>
                            <h6 className="mb-0">
                              {item.variant_name} x {item.quantity}
                            </h6>

                            <div className="mb-3">
                              {item.addons?.map((addon_i: any, i: any) => (
                                <span className="my-0">
                                  {i != 0 && ", "}
                                  {addon_i.name} x {addon_i.quantity}
                                </span>
                                // </div>
                              ))}
                            </div>


                          </div>


                        </div>
                      ))}
                    </Link>

                    <div className="accordion-item">
                      <div
                        id={"flush-collapseThree" + i_item}
                        className="accordion-collapse collapse justify-content-end"
                        aria-labelledby={i_item}
                        data-bs-parent="#accordionFlushExample"
                      >
                        <div className="accordion-body">
                          <div className="d-flex justify-content-between mt-2">
                            <div className="fw-bold ms-2 ">item total</div>
                            <div className="fw-bold me-2">
                              {" "}
                              &#8377;{ele.amount}
                            </div>
                          </div>

                          <div className="d-flex justify-content-between">
                            <p className="text-muted ms-2">package price</p>
                            <small className="text-muted me-2">
                              {" "}
                              &#8377;12
                            </small>
                          </div>
                          <div className="d-flex justify-content-between">
                            <p className="text-muted ms-2">GST</p>
                            <small className="text-muted me-2">
                              {" "}
                              &#8377;12
                            </small>
                          </div>

                          <div className="d-flex justify-content-between">
                            <p className="text-muted ms-2">Discount</p>
                            <small className="text-muted me-2">
                              {" "}
                              &#8377;0.00
                            </small>
                          </div>

                          <div className="d-flex justify-content-between">
                            <p className="text-muted ms-2">Delivery Charges</p>
                            <small className="text-muted me-2">
                              {" "}
                              &#8377;{ele.delivery_charges}
                            </small>
                          </div>
                        </div>
                      </div>
                      <div className="accordion-header mt-2 mb-3" id={i_item}>
                        <div
                          className="collapsed"
                          type="button"
                          data-bs-toggle="collapse"
                          data-bs-target={"#flush-collapseThree" + i_item}
                          aria-expanded="false"
                          aria-controls="flush-collapseThree"
                        >
                          <div className="d-flex">
                            <div className="fw-bold">
                              Total Bill{" "}
                              <i
                                class="fa fa-angle-down"
                                aria-hidden="true"
                              ></i>
                            </div>
                            <div className="fw-bold ms-auto me-2">
                              &#x20B9;{ele.total_amount}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>


                    <div className="d-flex justify-content-center">
                      {ele.order_status == "Accepted" &&
                        ele.products.length != 0 ? (
                        <>
                          <button
                            className="btn btn-icon btn-primary rounded ctc-button mb-2"

                            style={{ overflow: "hidden" }}
                            onClick={(event) => {
                              SetChooseItemModal({
                                is_open: true,
                                id: ele.id,
                                data: {
                                  product: ele.products,
                                  units: data.units,
                                },
                              });


                            }}
                          >
                            <span className="btn-inner d-flex align-items-center">
                              <span className="px-lg-4 px-4 fw-bold ">
                                Plan Shipment
                              </span>
                            </span>
                          </button>
                        </>
                      ) : (
                        ""
                      )}

                      {ele.order_status == "New" && (
                        <div className="d-flex">
                          <button
                            className="btn btn-icon btn-outline-dark rounded ctc-button "

                            style={{ overflow: "hidden" }}
                            onClick={(event) => {

                              SetPrepTimeModal({
                                is_open: true,
                                // id: ele_pro.id,
                                brand: id_value.brand_id,
                                approx_time: ele.approx_preparation_duration,
                                outlet: id_value.outlet_id,
                                order_id: ele.id,
                              });
                            }}
                          >
                            <span className="btn-inner d-flex align-items-center">
                              <span className="px-lg-4 px-4 fw-bold">
                                ACCEPT
                              </span>
                            </span>
                          </button>

                          <button
                            className="btn btn-icon btn-outline-danger rounded ctc-button ms-3 me-auto  "
                            onClick={(event) => {
                              SetRejectModal({
                                is_open: true,
                                data: {
                                  id: ele.id,
                                },
                              });
                            }}
                          >
                            <span className="btn-inner d-flex align-items-center">
                              <span className="px-lg-4 px-4 fw-bold">
                                REJECT
                              </span>
                            </span>
                          </button>
                        </div>
                      )}
                    </div>
                    {ele.delivery?.map((ele_pro: any, i_item: any) => (
                      <div className="my-2 mx-auto">
                        {ele_pro.status && (
                          <div className="d-flex mb-2">
                            <div className="ms-auto">
                              {ele_pro.status}{" "}
                              <i class="fas fa-circle text-cl-green"></i>
                            </div>
                          </div>
                        )}
                        <div className="d-flex">
                          <Link
                            to={
                              "/outlet/" +
                              id_value.brand_id +
                              "/" +
                              id_value.outlet_id +
                              "/order_details" +
                              "/" +
                              ele.id
                            }
                            className="text-dark"
                          >
                            <h6>Shipment {i_item + 1}</h6>
                          </Link>


                          {ele_pro.hyperlocal == false && (
                            <div className="ms-auto">
                              {" "}
                            <div className="dropdown">
                                <button
                                  className="btn dropdown-toggle"
                                  type="button"
                                  id="dropdownMenuButton1"
                                  data-bs-toggle="dropdown"
                                  aria-expanded="false"
                                >
                                  <i className="fas fa-ellipsis-h"></i>
                                </button>
                                <ul
                                  className="dropdown-menu"
                                  aria-labelledby="dropdownMenuButton1"
                                >
                                  <li>
                                    <a
                                      className="dropdown-item"
                                      href="#"
                                      onClick={(event) => {
                                        console.log("edit_outlet");
                                        SetEditItemModal({
                                          is_open: true,
                                          id: ele_pro.id,
                                          data: {
                                            product: ele_pro.products,
                                            delivery: ele.delivery,
                                            main_product: ele.products,
                                          },
                                        });


                                      }}
                                    >
                                      {" "}
                                      <Feather
                                        name="edit-3"
                                        size={16}
                                        color="gray"
                                      />{" "}
                                      Edit
                                    </a>
                                  </li>
                                  <li>
                                    <a
                                      className="dropdown-item"
                                      href={
                                        "https://sellers.1superapp.com/app_dev/outlet/download_shipment_invoice?brand=" +
                                        id_value.brand_id +
                                        "&outlet=" +
                                        id_value.outlet_id +
                                        "&delivery_id=" +
                                        ele_pro.id
                                      }
                                      rel="noopener noreferrer"
                                      target="_blank"
                                    >
                                      <Feather
                                        name="download"
                                        size={16}
                                        color="gray"
                                      />{" "}
                                      Download shipment invoice
                                    </a>
                                  </li>
                                  <li>
                                    <a
                                      className="dropdown-item"

                                      rel="noopener noreferrer"
                                      target="_blank"
                                    >
                                      <Feather
                                        name="download"
                                        size={16}
                                        color="gray"
                                      />{" "}
                                      Download shipment label
                                    </a>
                                  </li>
                                  <li>
                                    <a
                                      className="dropdown-item"

                                      rel="noopener noreferrer"
                                      target="_blank"
                                    >
                                      <Feather
                                        name="download"
                                        size={16}
                                        color="gray"
                                      />{" "}
                                      Download shipment manifest
                                    </a>
                                  </li>
                                  <li>
                                    <a
                                      className="dropdown-item"
                                      href="#"
                                      onClick={(event) => {
                                        SetDeleteShipModal({
                                          is_open: true,
                                          data: {
                                            id: ele_pro.id,
                                          },
                                        });
                                      }}
                                    >
                                      <Feather
                                        name="trash"
                                        size={16}
                                        color="gray"

                                      // accept(ele.id);
                                      />{" "}
                                      Delete
                                    </a>
                                  </li>
                                </ul>
                              </div>
                            </div>
                          )}
                        </div>
                        <Link
                          to={
                            "/outlet/" +
                            id_value.brand_id +
                            "/" +
                            id_value.outlet_id +
                            "/order_details" +
                            "/" +
                            ele.id
                          }
                          className="text-dark"
                        >
                          {ele_pro.products?.map((item: any, i_item: any) => (
                            <div className="basic-list my-2">

                              <div>
                                <h6 className="mb-0">
                                  {item.variant_name} x {item.quantity}
                                </h6>

                                <div className="mb-3">
                                  {item.addons?.map((addon_i: any, i: any) => (
                                    <span className="my-0">
                                      {i != 0 && ", "}
                                      {addon_i.name} x {addon_i.quantity}
                                    </span>
                                    // </div>
                                  ))}
                                </div>


                              </div>


                            </div>
                          ))}

                          {ele_pro.products.length == 0 && <p>No Data</p>}
                        </Link>
                        {ele_pro.products.length > 0 && (
                          <>
                            <div className="d-flex">
                              <Link
                                to={
                                  "/outlet/" +
                                  id_value.brand_id +
                                  "/" +
                                  id_value.outlet_id +
                                  "/order_details" +
                                  "/" +
                                  ele.id
                                }
                                className="text-dark"
                              >
                                <div className=" ">Package Details:</div>
                              </Link>
                              <div
                                className=" ms-auto"
                                onClick={(event) => {
                                  SetEditPackageModal({
                                    is_open: true,
                                    id: ele_pro.id,
                                    data: {
                                      // product: ele.products,
                                      units: data.units,
                                      id: ele_pro.id,
                                      package_details: ele_pro.package_details,
                                    },
                                  });
                                }}
                              >
                                <i className="fas fa-edit "></i>
                              </div>

                            </div>

                            <Link
                              to={
                                "/outlet/" +
                                id_value.brand_id +
                                "/" +
                                id_value.outlet_id +
                                "/order_details" +
                                "/" +
                                ele.id
                              }
                              className="text-dark"
                            >
                              {ele_pro.package_details.package_breadth ==
                                null ? (
                                <p>No Package Data</p>
                              ) : (
                                <>
                                  <div>
                                    l x b x h :{" "}
                                    <span className="text-dark">
                                      {ele_pro.package_details.package_length +
                                        " " +
                                        ele_pro.package_details
                                          .package_length_unit_name}
                                    </span>{" "}
                                    x
                                    <small className="text-dark">
                                     {" "}
                                      <span className="text-dark">
                                        {ele_pro.package_details
                                          .package_breadth +
                                          " " +
                                          ele_pro.package_details
                                            .package_breadth_unit_name}
                                      </span>{" "}
                                    </small>{" "}
                                    x
                                    <small className="text-dark">
                                      {" "}
                                      <span className="text-dark">
                                        {ele_pro.package_details
                                          .package_height +
                                          " " +
                                          ele_pro.package_details
                                            .package_height_unit_name}
                                      </span>
                                    </small>{" "}
                                    ,
                                    <div>
                                      w :{" "}
                                      <small className="text-dark">
                                        {ele_pro.package_details
                                          .package_weight +
                                          " " +
                                          ele_pro.package_details
                                            .package_weight_unit_name}
                                      </small>
                                    </div>

                                  </div>
                                </>
                              )}
                            </Link>
                            {ele_pro.status == "Preparing Order" && (
                              <div className="d-flex">


                                <div className="ms-auto">

                                  <CountdownCircleTimer
                                    {...timerProps}
                                    colors={[
                                      "#1D741B",
                                      "#0E86D4",
                                      "#FF2511",
                                      "#fffff",
                                    ]}
                                    colorsTime={[20, 10, 5, 0]}
                                    duration={hourSeconds}
                                    initialRemainingTime={
                                      ele_pro.remaining_preparing_duration %
                                      hourSeconds
                                    }
                                    onComplete={(totalElapsedTime) => ({
                                      shouldRepeat:
                                        ele_pro.remaining_preparing_duration -
                                        totalElapsedTime >
                                        minuteSeconds,
                                    })}
                                  >
                                    {({ elapsedTime, color }) => (
                                      <span style={{ color }}>
                                        {renderTime(
                                          "",
                                          getTimeMinutes(
                                            hourSeconds - elapsedTime
                                          )
                                        )}
                                      </span>
                                    )}
                                  </CountdownCircleTimer>
                                </div>
                              </div>
                            )}

                            <hr></hr>

                            {ele.delivery[0].hyperlocal == true &&
                              ele.delivery[0].hyperlocal_pickup
                                .delivery_partner_name && (
                                <div className="d-flex allign-items-center">
                                  <div className="d-flex">
                                    {ele.delivery[0].hyperlocal_pickup
                                      .delivery_partner_dp ? (
                                      <img
                                        src={
                                          ele.delivery[0].hyperlocal_pickup
                                            .delivery_partner_dp
                                        }
                                        alt="16.a1d4f3f3"
                                        className="rounded-float-start"
                                        height="31"
                                        width="31"
                                        style={{ borderRadius: "50px" }}
                                      />
                                    ) : (
                                      <i className="fa fa-user m-2"></i>
                                    )}
                                    <div>
                                      <div className="ms-1 fw-bolder ">
                                        {
                                          ele.delivery[0].hyperlocal_pickup
                                            .delivery_partner_name
                                        }
                                      </div>
                                      <div className=" ms-1">
                                        {
                                          ele.delivery[0].hyperlocal_pickup
                                            .company_name
                                        }
                                      </div>

                                      <div className="d-flex align-items-center">
                                        <div className="d-flex alig-items-center">
                                          <div className=" ps-1">
                                            {
                                              ele.delivery[0].hyperlocal_pickup
                                                .otp
                                            }
                                          </div>
                                        </div>

                                        {ele.delivery[0].hyperlocal_pickup
                                          .delivery_partner_mobile && (
                                            <>
                                              <div className=" px-2">|</div>
                                              <div className="d-flex">
                                                <a
                                                  href={
                                                    "tel:" +
                                                    ele.delivery[0]
                                                      .hyperlocal_pickup
                                                      .delivery_partner_mobile
                                                  }
                                                >
                                                  <MaterialCommunityIcons
                                                    name="phone"
                                                    size={12}
                                                    color="#888"
                                                  />
                                                </a>{" "}
                                              </div>
                                            </>
                                          )}

                                        {ele.delivery[0].live_tracking ==
                                          true && (
                                            <>
                                              <div className=" px-2">|</div>
                                              <div className="d-flex">
                                                <img
                                                  onClick={() => {
                                                    SetMapDriverModal({
                                                      is_open: true,
                                                      lat: ele.delivery[0]
                                                        ?.hyperlocal_pickup
                                                        ?.pickup_lat,
                                                      lon: ele.delivery[0]
                                                        ?.hyperlocal_pickup
                                                        ?.pickup_lng,
                                                      id: ele.delivery[0].id,
                                                    });
                                                  }}
                                                  src={
                                                    "https://img.icons8.com/ios/14/map-marker.png"
                                                  }
                                                />
                                              </div>
                                            </>
                                          )}
                                      </div>
                                    </div>
                                  </div>

                                  <div className="ms-auto">
                                    <div className="ms-2">
                                      {ele.delivery[0].hyperlocal_pickup.status}{" "}
                                      {ele.order_status == "Rejected" ? (
                                        <i
                                          class="fa fa-ban text-cl-green"
                                          aria-hidden="true"
                                        ></i>
                                      ) : (
                                        <i class="fas fa-shopping-cart text-cl-green"></i>
                                      )}
                                    </div>
                                    <div className="mb-0 fw-bold ms-4">
                                      #{ele.id}
                                    </div>
                                  </div>
                                </div>
                              )}

                            <div className="d-flex">
                              {ele_pro.status == "Preparing Order" && (
                                <button
                                  className="btn btn-icon btn-primary rounded ctc-button mx-auto mt-2"
                                  style={{ overflow: "hidden" }}
                                  onClick={(event) => {
                                    {
                                      ele_pro.package_details.package_breadth ==
                                        null
                                        ? SetCreatePackageModal({
                                          is_open: true,
                                          id: ele_pro.id,
                                          data: {
                                            units: data.units,
                                            id: ele_pro.id,
                                          },
                                        })
                                        : submit_ready_ship(ele_pro.id);
                                    }
                                  }}
                                >
                                  Ready
                                </button>
                              )}

                              {!ele_pro.status && (
                                <button
                                  className="btn btn-icon btn-primary rounded ctc-button mx-auto mt-2"
                                  style={{ overflow: "hidden" }}
                                  onClick={(event) => {
                                    SetPrepTimeModal({
                                      is_open: true,
                                      order_id: ele_pro?.id,
                                    });
                                  }}
                                >
                                  Prepare
                                </button>
                              )}
                            </div>
                          </>
                        )}
                        <hr></hr>
                      </div>
                    ))}
                  </div>
                </div> */}
        {/* {next_page ? (
          <p
            className="text-prime fw-bold text-center my-2 cursor"
            onClick={() => {
              load_more();
            }}
          >
            Load More
          </p>
        ) : null} */}
      </div>
      <ModalOrderConfirmed
        open={openModal.is_open}
        data={openModal.data}
        close={ModalOnClose}
      />
      <ModalChooseItems
        open={chooseItemModal.is_open}
        data={chooseItemModal.data}
        id={chooseItemModal.id}
        // close={ModalOnClose}
        close={(data) => {
          console.log("close in", data);

          SetChooseItemModal((prevValue) => {
            prevValue.is_open = false;

            console.log("prevValue.is_open ", prevValue);
            return { ...prevValue };
          });
          if (data.action == "edit") {
            get_order(id_value.type);
          }
        }}
      />
      <ModalPackageDetails
        open={createPackageModal.is_open}
        data={createPackageModal.data}
        id={chooseItemModal.id}
        // close={ModalOnClose}
        close={(data) => {
          console.log("close in");

          SetCreatePackageModal((prevValue) => {
            prevValue.is_open = false;

            console.log("prevValue.is_open ", prevValue);
            return { ...prevValue };
          });

          if (data.action == "save") {
            get_order(id_value.type);
          }
        }}
      />
      <ModalEditPackageDetails
        open={editPackageModal.is_open}
        data={editPackageModal.data}
        id={editPackageModal.id}
        // close={ModalOnClose}
        close={(data) => {
          console.log("close in");

          SetEditPackageModal((prevValue) => {
            prevValue.is_open = false;

            console.log("prevValue.is_open ", prevValue);
            return { ...prevValue };
          });

          if (data.action == "edit") {
            get_order(id_value.type);
          }
        }}
      />
      <ModalEditItems
        open={editItemModal.is_open}
        data={editItemModal.data}
        id={editItemModal.id}
        close={(data: any) => {
          SetEditItemModal((prevValue) => {
            prevValue.is_open = false;
            return { ...prevValue };
          });

          if (data.action == "edit") {
            get_order(id_value.type);
          }
        }}
      />

      {/* <ModalPrepareTime
        open={prepTimeModal.is_open}
        brand={prepTimeModal.brand}
        outlet={prepTimeModal.outlet}
        order_id={prepTimeModal.order_id}
        approx_time={prepTimeModal.approx_time}
        close={(data: any) => {
          console.log(data);
          SetPrepTimeModal((prevValue) => {
            prevValue.is_open = false;
            return { ...prevValue };
          });

          if (data.action == "close") {
            get_order(view_type);
          }
        }}
      /> */}

      <ModalDeleteShipment
        open={deleteShipModal.is_open}
        data={deleteShipModal.data}
        close={(data: any) => {
          SetDeleteShipModal({
            is_open: false,
            data: {},
          });

          console.log(data);

          if (data.action == "delete") {
            get_order(id_value.type);
          }
        }}
      />
      <ModalLocationLive
        open={mapdriverModal.is_open}
        lat={mapdriverModal.lat}
        lon={mapdriverModal.lon}
        id={mapdriverModal.id}
        // id={deleteModal.id}
        close={(data: any) => {
          // console.log("Franchise modl on close :", data);
          SetMapDriverModal((prevValue: any) => {
            prevValue.is_open = false;
            return { ...prevValue };
          });
          if (data.action == "save") {
            // get_outlets();
          }
        }}
      />
      {order_data?.length > 0 ? (
        <ModalOrderTracking
          open={order_tracking_modal.is_open}
          delivery_id={order_tracking_modal.delivery_id}
          delivery_index={order_tracking_modal.delivery_index}
          order_details={order_tracking_modal.order_data}
          close={() => {
            SetOrderTrackingModal((prevalue: any) => {
              prevalue.is_open = false;
              prevalue.delivery_index = "";
              prevalue.delivery_id = "";
              prevalue.order_data = {};
              return { ...prevalue };
            });
          }}
        />
      ) : null}

      <ModalRejected
        open={rejectModal.is_open}
        data={rejectModal.data}
        close={(data: any) => {
          SetRejectModal({
            is_open: false,
            data: {},
          });

          console.log(data);

          if (data.action == "delete") {
            get_order(id_value.type);
          }
        }}
      />
    </div>
  );
}
